import React, { createContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "@hooks/useLocalStorage";
import { decodeToken } from "react-jwt";
import { AuthContext as AuthContextT } from "@typedef/index";
import { apiBaseUrl, post } from "@services/api.service";
import { useNotification } from "@hooks/useNotification";
import axios from "axios";
import { useMsal } from "@azure/msal-react";

export const AuthContext = createContext({} as AuthContextT);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser, removeUser] = useLocalStorage("user", null);
  const [, , removeMultiCloudItems] = useLocalStorage("onboardedCloudApps", []);
  const [xAuthProvider, setxAuthProvider] = useLocalStorage(
    "authProvider",
    "internal"
  );
  const [isLoading, setIsLoading] = useState(false);
  const { instance } = useMsal();
  const { openToast } = useNotification();

  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data: any) => {
    navigate("/dashboard");
    return;
    // api login here
    setIsLoading(true);
    post("userprofile/login", data)
      .then((res: any) => {
        const { token, refreshToken } = res.response.data;
        if (token) {
          const tokenDetails: any = decodeToken(token);
          axios
            .get(`${apiBaseUrl}/userprofile/access`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(({ data }: any) => {
              if (data.status === "OK") {
                setUser({
                  token,
                  refreshToken: refreshToken,
                  email: tokenDetails.email,
                  access: data.response.data.access,
                  currency: data.response.data.currency,
                  role: data.response.data.role,
                });
                setxAuthProvider("internal");
                setTimeout(() => {
                  setIsLoading(false);
                  navigate("/dashboard");
                }, 100);
              }
            });
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  // call this function to sign out logged in user
  const logout = () => {
    // remove token here
    instance.logoutPopup().catch((e) => {
      openToast({ content: e, type: "error" });
    });

    removeUser("user");
    removeMultiCloudItems("onboardedCloudApps");
    window.location.reload();
  };

  const value: AuthContextT = useMemo(
    () => ({
      user,
      login,
      logout,
      isLoading,
    }),
    // eslint-disable-next-line
    [user, isLoading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
